import { Component, OnInit, ViewChild, Injector } from "@angular/core";
import { WizardIndicatorsData } from "../../model/wizardindicators.data";
import { ChartInstanceService } from "../../services/chartInstance/chart.instance.service";
import { AChartComponent } from "../achart/achart.component";
import { EventType } from "../achart/achart.annotation.tools";
import { ScaleBarComponent } from "../scaleBar/scaleBar.component";
import { QuoteTabsActiveModeService } from "../../services/quoteTabsActiveMode/quoteTabsActiveMode.service";
import { MonitorSelectedSymbol } from "../../model/monitor.selected.symbol";

import {
    HistoryItemPeriod,
    getHistoryItemPeriodValue,
    getRangeFromHistoryItemPeriod
} from "../../interfaces/historyItem";
import { DataService } from "../../services/data/data.service";
import { historyPeriods } from "../../interfaces/historyItem";
import { monitorPeriodsService, selectedPeriods } from "../../services/monitorPeriods/monitorPeriods.service";
import { WorkspaceServiceService } from "../../services/workspace-service.service";
import { AppComponentBase } from "../../services/AppComponentBase";
import { QuotePanelsTabsList } from "../../enums/QuotePanelsTabs.list";
import { Subscription } from "rxjs";
import { IServiceResponse } from "../../interfaces/service.response";
import * as $ from "jquery";
import { setTimeout } from "timers";
@Component({
    selector: "app-quoteTabWizard",
    template: require('./quoteTabWizard.component.html'),
    styles: [require('./quoteTabWizard.component.scss')]
})
export class QuoteTabWizardComponent extends AppComponentBase implements OnInit {
    @ViewChild("SMomentum1") cMomentum1: ScaleBarComponent = new ScaleBarComponent();
    @ViewChild("SMomentum2") cMomentum2: ScaleBarComponent = new ScaleBarComponent();
    @ViewChild("SMomentum3") cMomentum3: ScaleBarComponent = new ScaleBarComponent();
    @ViewChild("buyAndSell") buyAndSell: ScaleBarComponent = new ScaleBarComponent();
    @ViewChild("Volatility") volatility: ScaleBarComponent = new ScaleBarComponent();

    private _wizardIndicatorsData: WizardIndicatorsData = new WizardIndicatorsData();
    private _Momentum_1: Number = 0;

    private _select1: any = HistoryItemPeriod.Hr24;
    private _select2: any = HistoryItemPeriod.Min90;
    private _select3: any = HistoryItemPeriod.Min5;

    private _buyandsell: string = "b&s";

    public get periods(): {
        id: number;
        label: string;
        css: string;
        Order: number;
        Standard?: boolean;
        Oanda?: boolean;
    }[] {
        return this.workspace.periodsList;
    }

    public set periods(
        value: {
            id: number;
            label: string;
            css: string;
            Order: number;
            Standard?: boolean;
            Oanda?: boolean;
        }[]
    ) {
        this.workspace.periodsList = value;
    }

    public set select1(v: any) {
        this._select1 = v;

        let data: { [id: string]: string } = {};

        data["M1"] = String(this.Momentum1);
        data["M2"] = String(this.Momentum2);
        data["M3"] = String(this.Momentum3);

        this.updateScalebars(data);
    }

    public get select1(): any {
        return this._select1;
    }

    public set select2(v: any) {
        this._select2 = v;
        let data: { [id: string]: string } = {};

        data["M1"] = String(this.Momentum1);
        data["M2"] = String(this.Momentum2);
        data["M3"] = String(this.Momentum3);

        this.updateScalebars(data);
    }

    public get select2(): any {
        return this._select2;
    }

    public set select3(v: any) {
        this._select3 = v;
        let data: { [id: string]: string } = {};

        data["M1"] = String(this.Momentum1);
        data["M2"] = String(this.Momentum2);
        data["M3"] = String(this.Momentum3);

        this.updateScalebars(data);
    }

    public get select3(): any {
        return this._select3;
    }

    public get buyandsellIndex() {
        return this._buyandsell;
    }

    get activeTab(): QuotePanelsTabsList {
        return this.workspace.activeTab;
    }

    private k = 0;
    public unsubscribed: boolean = true;
    private _monitor?: MonitorSelectedSymbol;

    constructor(injector: Injector, private monitorPeriodsService: monitorPeriodsService) {
        super(injector);
        this.activeQuoteTab.subscriber.subscribe(currentTabId => {
            if (this.activeTab != QuotePanelsTabsList.WIZARD && this.unsubscribed == false) {
                //    this.chartInstanceService.select.unsubscribe();
                this.unsubscribed = true;
            }
            if (this.activeTab == QuotePanelsTabsList.WIZARD && this.selectedChart != null) {
                //this.selectBS
                this.InitMonitor();
                this.updateM();

                this.onChangeBS(this.selectBS);
                this.onChangeVL(this.selectVL);
            }
            if (this.activeTab == QuotePanelsTabsList.WIZARD) {
                this.unsubscribed = false;
            }
        });
        // console.log(this.selectedChart.symbol);
        // console.log(this.workspaceService.data.activeTab)

        this.dataService.dataSubscriber.subscribe(response => {
            this.updateFromResponse(response);
        });

        this.chartInstanceService.select.subscribe(c => {
            if (this.previousSymbol != this.selectedChart.symbol || this.previousPeriod != this.selectedChart.period) {
                if (this.selectedChart && this.selectedChart.chart) {
                    this.selectedChart.chart.listen(
                        EventType.SELECTED_RANGE_CHANGE,
                        this.selectedRangeChanged,
                        false,
                        this
                    );
                    // if (this.activeTab == QuotePanelsTabsList.WIZARD && this.selectedChart != null) {
                    //     this.InitMonitor();
                    //     this.updateM();
                    // }
                }
                if (this.activeTab == QuotePanelsTabsList.WIZARD && this.selectedChart != null) {
                    this.InitMonitor();
                    this.updateM();
                }

                //  this.selectedChart.dataTable;
            }

            this.previousSymbol = this.selectedChart.symbol;
            this.previousPeriod = this.selectedChart.period;
            // this.buyAndSell.scaleBarValue = "0";
        });

        this.chartInstanceService.unselect.subscribe(c => {
            if (this.selectedChart && this.selectedChart.chart) {
                this.selectedChart.chart.unlisten(
                    EventType.SELECTED_RANGE_CHANGE,
                    this.selectedRangeChanged,
                    false,
                    this
                );
            }
        });

        this.globaGridMode.subscribeSymbolChanged(v => {
            this.InitMonitor();
            this.updateM();
        });

        this.workspace.globaGridMode.refreshProviderSignal.subscribe(v => {
            console.log("refreshProviderSignaTABWIZARD");
            this._monitor = undefined;

            this._wizardIndicatorsData = new WizardIndicatorsData();
            // console.log(data);
            this.cMomentum1.scaleBarValue = "0";

            this.cMomentum2.scaleBarValue = "0";

            this.cMomentum3.scaleBarValue = "0";

            this.buyAndSell.scaleBarValue = "0";
            this.volatility.scaleBarValue = "0";

            if (this.activeTab != QuotePanelsTabsList.WIZARD && this.unsubscribed == false) {
                this.unsubscribed = true;
            }
            if (this.activeTab == QuotePanelsTabsList.WIZARD && this.selectedChart != null) {
                this.InitMonitor();
                this.updateM();
            }
            if (this.activeTab == QuotePanelsTabsList.WIZARD) {
                this.unsubscribed = false;
            }
        });
    }
    private previousSymbol: string = "";
    private previousPeriod: number = -1000;
    public Momentum1: any = 0;
    public Momentum2: any = 0;
    public Momentum3: any = 0;

    selectedRangeChanged(e: Object): boolean {
        this.updateM();
        return true;
    }

    private async updateFromResponse(response: IServiceResponse) {
        if (response.T && this.selectedChart) {
            var q = response.T.filter(x => x.S == this.selectedChart.symbol);
            if (q.length > 0 && this.buyAndSell && this._monitor) {
                this.buyAndSell.scaleBarValue = String(this._monitor.buyAndSell);
            }
        }
    }

    public tm: any;
    public async InitMonitor() {
        clearTimeout(this.tm);
        if (!this.workspace.loadedChartData) {
            //this.selectedChart.Config.Symbol;
            this.tm = setTimeout(() => {
                this.InitMonitor();
            }, 1000);

            return;
        } else {
            //   debugger;
            //    this.selectedChart.Config.Symbol
            this._monitor = undefined;
        }

        if (this.activeTab == QuotePanelsTabsList.WIZARD && this.selectedChart != null) {
            //      debugger;

            this.selectedChart.wizard = this;
            this._monitor = new MonitorSelectedSymbol(
                this.dataService,
                this.workspaceService.data,
                this.selectedChart.symbol,
                100000,
                this.monitorPeriodsService,
                this.wakeUp
            );

            this._monitor.enableBuyAndSell = true;
            this._monitor.m1Period = this.select1;
            this._monitor.m2Period = this.select2;
            this._monitor.m3Period = this.select3;
            this._monitor.defaultNumberofPoints = 1000;
            this._monitor.requestForData(this);

            this.buyAndSell.scaleBarValue = String(this._monitor.buyAndSell);

            this.updateM();
        }
    }

    public async update() {
        this.updateM();
    }

    private _m1OutOfData: boolean = false;
    public get m1OutOfData(): boolean {
        return this._m1OutOfData;
    }
    public set m1OutOfData(value: boolean) {
        this._m1OutOfData = value;
    }

    private _m2OutOfData: boolean = false;
    public get m2OutOfData(): boolean {
        return this._m2OutOfData;
    }
    public set m2OutOfData(value: boolean) {
        this._m2OutOfData = value;
    }

    private _m3OutOfData: boolean = false;
    public get m3OutOfData(): boolean {
        return this._m3OutOfData;
    }
    public set m3OutOfData(value: boolean) {
        this._m3OutOfData = value;
    }

    public async updateM() {
        this.runOverlayM1 = false;
        this.runOverlayM2 = false;
        this.runOverlayM3 = false;

        if (!this.selectedChart) return;
        var ranges = this.selectedChart.chart.getSelectedRange();

        let lastQuoteTime = this.selectedChart._lastQuoteData[0];
        let deltaRanges = ranges.lastSelected - ranges.firstSelected;
        let endRange = lastQuoteTime <= ranges.lastSelected ? lastQuoteTime : ranges.lastSelected;
        let startRange = lastQuoteTime <= ranges.lastSelected ? endRange - deltaRanges : ranges.firstSelected;

        if (this._monitor) {
            if (this._monitor._dataVL !== undefined) {
                this._monitor
                    .getVolatility(this._monitor._dataVL, endRange, this.selectVL, ranges.firstSelected)
                    .then(r => {
                        this.volatility.scaleBarValue = String(r);
                    });
            }

            this._monitor.chartRange = endRange;
            this._monitor.wizardRequest = true;
            this._monitor
                .getValueM1(endRange, this.select1, startRange)
                .then((value: any) => {
                    this.Momentum1 = value;
                })
                .catch(e => {
                    console.error(e);
                });

            this._monitor
                .getValueM2(endRange, this.select2, startRange)
                .then((value: any) => {
                    this.Momentum2 = value;
                })
                .catch(e => {
                    console.error(e);
                });

            this._monitor
                .getValueM3(endRange, this.select3, startRange)
                .then((value: any) => {
                    this.Momentum3 = value;
                })
                .catch(e => {
                    console.error(e);
                });

            let data: { [id: string]: string } = {};

            this.Momentum1 = this.Momentum1 == -999999 ? 0 : this.Momentum1;
            this.Momentum2 = this.Momentum2 == -999999 ? 0 : this.Momentum2;
            this.Momentum3 = this.Momentum3 == -999999 ? 0 : this.Momentum3;

            if (isNaN(this.Momentum1)) {
                this.Momentum1 = 0;
                this.runOverlayM1 = true;
            }

            if (isNaN(this.Momentum2)) {
                this.Momentum2 = 0;
                this.runOverlayM2 = true;
            }

            if (isNaN(this.Momentum3)) {
                this.Momentum3 = 0;
                this.runOverlayM3 = true;
            }

            data["M1"] = String(this.Momentum1);
            data["M2"] = String(this.Momentum2);
            data["M3"] = String(this.Momentum3);

            //       console.log([this._monitor.box.Symbol, this.selectedChart.symbol, this._monitor.buyAndSell]);

            //    this.onChangeBS(this.selectBS);
            //      this._monitor.updateBS();
            data[this.buyandsellIndex] = String(this._monitor.buyAndSell);

            this._monitor.returnFix();

            if (this.unsubscribed == false) {
                this.updateScalebars(data);
                //  this.cMomentum1.scaleBarValue=String(this.k);
                //  this.cMomentum2.scaleBarValue=String(100-this.k);
                //  this.cMomentum3.scaleBarValue=String(-100+this.k);
            }
        }
    }

    private _runOverlayM1: boolean = false;
    public get runOverlayM1(): boolean {
        return this._runOverlayM1;
    }
    public set runOverlayM1(value: boolean) {
        this._runOverlayM1 = value;
    }

    private _runOverlayM2: boolean = false;
    public get runOverlayM2(): boolean {
        return this._runOverlayM2;
    }
    public set runOverlayM2(value: boolean) {
        this._runOverlayM2 = value;
    }

    private _runOverlayM3: boolean = false;
    public get runOverlayM3(): boolean {
        return this._runOverlayM3;
    }
    public set runOverlayM3(value: boolean) {
        this._runOverlayM3 = value;
    }

    private updatePeriodSerive() {
        let t: selectedPeriods = {
            s1: <HistoryItemPeriod>this.select1,
            s2: <HistoryItemPeriod>this.select2,
            s3: <HistoryItemPeriod>this.select3
            //  BS: <HistoryItemPeriod>this.selectBS,
            //   VL: <HistoryItemPeriod>this.selectVL
        };
        this.monitorPeriodsService.selectedPeriods.next(t);
    }

    onChangeS1(newObj: any) {
        // console.log(newObj);
        // if (this._monitor !== undefined) {
        //     this._monitor.m1Period = newObj;
        //     this._monitor.requestForData(this);
        // }
        this.select1 = newObj;
        this.updatePeriodSerive();
    }

    onChangeS2(newObj: any) {
        // if (this._monitor !== undefined) {
        //     this._monitor.m2Period = newObj;
        //     this._monitor.requestForData(this);
        // }
        this.select2 = newObj;

        this.updatePeriodSerive();
    }

    onChangeS3(newObj: any) {
        // if (this._monitor !== undefined) {
        //     this._monitor.m3Period = newObj;
        //     this._monitor.requestForData(this);
        // }
        this.select3 = newObj;
        this.updatePeriodSerive();
    }

    public updateScalebars(data: any) {
        // console.log(data);
        this.cMomentum1.scaleBarValue = data["M1"];

        this.cMomentum2.scaleBarValue = data["M2"];

        this.cMomentum3.scaleBarValue = data["M3"];

        this.buyAndSell.scaleBarValue = String(this._monitor!.buyAndSell);
    }

    ngOnInit() {
        setTimeout(() => {
            this.selectBS = this.selectedChart.period;
            this.selectVL = this.selectedChart.period;

            this.onChangeBS(this.selectBS);
            this.onChangeVL(this.selectVL);

            $(".ti-scroller").mCustomScrollbar({
                axis: "y",
                theme: "inset-3", // "minimal-dark",
                scrollbarPosition: "outside",
                alwaysShowScrollbar: 0, // 0,1,2
                scrollButtons: {
                    enable: true
                },
                mouseWheel: {
                    enable: true,
                    scrollAmount: 5
                }
            });
        }, 1000);
    }

    get wizardIndicatorsData(): WizardIndicatorsData {
        return this._wizardIndicatorsData;
    }

    private getValueM(data: anychart.data.Table, endDate?: number, period?: HistoryItemPeriod) {
        var redCtx: anychart.math.sma.Context = anychart.math.sma.initContext(89);
        var yellowCtx: anychart.math.sma.Context = anychart.math.sma.initContext(89);
        var mapping = data.mapAs();

        //    mapping.addField("dt", 0);// key - DateTime
        //    mapping.addField("open", 1);
        mapping.addField("high", 2);
        mapping.addField("low", 3);
        mapping.addField("close", 4);

        var startDate = endDate && period ? endDate - getHistoryItemPeriodValue(period) * 100 : -1;

        var sel =
            startDate > 0 && endDate
                ? mapping.createSelectable().select(startDate, endDate)
                : mapping.createSelectable().selectAll();
        var iter = sel.getIterator();

        var res = 0;
        while (iter.advance()) {
            var high = iter.get("high");
            var low = iter.get("low");
            var c = iter.get("close");

            var red = anychart.math.sma.calculate(redCtx, low);
            var yellow = anychart.math.sma.calculate(yellowCtx, high);

            if (c < red) {
                res = res > 0 ? 0 : res;
                res--;
            } else if (c > yellow) {
                res = res < 0 ? 0 : res;
                res++;
            }
        }
        //  console.log(` Symbol: ${this.Symbol} res ${res}`);
        return res;
    }

    ////////////////////////////////
    private _selectVL: any;
    public get selectVL(): any {
        return this._selectVL;
    }
    public set selectVL(value: any) {
        this._selectVL = value;
    }

    private _selectBS: any;
    public get selectBS(): any {
        return this._selectBS;
    }
    public set selectBS(value: any) {
        this._selectBS = value;
    }

    onChangeVL(newObj: any) {
        // console.log(newObj);
        // if (this._monitor !== undefined) {
        //     this._monitor.VLPeriod= newObj;
        //     this._monitor.requestForData(this);
        // }
        this.selectVL = newObj;
        //  this.updatePeriodSerive();
        if (this._monitor !== undefined) {
            this._monitor.setNewVLperiod(newObj);
        }
    }

    onChangeBS(newObj: any) {
        //   console.log(newObj);
        //   if (this._monitor !== undefined) {
        //       this._monitor.BSPeriod = newObj;
        //       this._monitor.requestForData(this);
        //   }
        this.selectBS = newObj;
        //this.updatePeriodSerive();
        if (this._monitor !== undefined) {
            this._monitor.setNewBSperiod(newObj);
        }
    }
}
